import React from 'react'
import PropTypes from 'prop-types'

// Components'
import { Avatar, Text, Popup } from '../../../..'

// Hooks
import { useBranding } from '../../../../../hooks/branding'

// Assets
import { Lock } from '../../../../Svg'

// styles
import styles from './Forbidden.module.scss'

const Forbidden = ({ onClose }) => {
  const { customerPhotoUri, customerFullName } = useBranding()

  return (
    <Popup onClose={onClose}>
      <div className={styles.container}>
        <Avatar className={styles.avatar} src={customerPhotoUri} />
        <Lock className={styles.lock} />
        <Text color='white' weight='bold' size='l'>
          This isn’t available to you yet
        </Text>
        <Text color='gray'>
          <Text element='span' weight='bold'>
            {customerFullName}{' '}
          </Text>
          would need to upgrade their account to unlock this area for you.
        </Text>
      </div>
    </Popup>
  )
}

Forbidden.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default Forbidden
